import { render, staticRenderFns } from "./loginCard_desktop.vue?vue&type=template&id=66a5b875&scoped=true&"
import script from "./loginCard_desktop.vue?vue&type=script&lang=js&"
export * from "./loginCard_desktop.vue?vue&type=script&lang=js&"
import style0 from "./loginCard_desktop.vue?vue&type=style&index=0&id=66a5b875&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a5b875",
  null
  
)

export default component.exports